<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium"
            >Registro de cotizaciones</span
          >
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-menu rounded="0" offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="#023145"
                class="white--text float-right"
                v-bind="attrs"
                v-on="on"
                @click="handleShowCreate"
              >
                Nuevo
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_sale"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <v-col cols="3" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('ventas.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="sale"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todos los registros
                </span>
                <v-divider></v-divider>
              </template>

              <!-- <template v-slot:item.name="{item}" v-if="item.customer">
                                <span class="label-office">{{ item.customer.name }}</span>                                
                            </template> -->
              <template v-slot:item.customer_fullname="{ item }">
                <span v-if="item.client_id">
                  {{ item.client_name }}
                </span>
                <span v-else-if="item.customer_id">
                  {{ item.customer_surname + " " + item.customer_name }}
                </span>
                <span v-else>
                  {{ "-" }}
                </span>
                <!-- <span v-if="item.client" class="label-office">{{
                  item.client.name
                }}</span>
                <span v-else-if="item.company_customer" class="label-office">{{
                  item.company_customer.name
                }}</span>
                <span v-else-if="item.customer" class="label-office">{{
                  item.customer.surname + " " + item.customer.name
                }}</span> -->
              </template>

              <template v-slot:item.document="{ item }">
                <span v-if="item.client_id" class="label-office">{{
                  item.client_ruc
                }}</span>
                <span v-else-if="item.company_customer" class="label-office">{{
                  item.company_customer.ruc
                }}</span>
                <span v-else-if="item.customer_id" class="label-office">{{
                  item.customer_document
                }}</span>
                <span v-else>{{ "-" }}</span>
              </template>

              <!-- <template v-slot:item.name="{item}" v-if="item.company">
                                <span class="label-office">{{ item.company.name }}</span>                                
                            </template> -->
              <template v-slot:item.orden="{ item }">
                <v-btn
                  icon
                  small
                  dark
                  color="blue"
                  @click="handlePrintVoucher(item)"
                >
                  <v-icon size="20">fas fa-print</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  dark
                  color="blue"
                  @click="convertCotizacionToSale(item)"
                >
                  <v-icon size="20">fa-solid fa-bell</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <Filters ref="filters" @hanleChangeFilter="hanleChangeFilter"></Filters>

    <download-products ref="downloadProducts"></download-products>
    <upload-products ref="uploadProducts"></upload-products>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import router from "@/router/index";
import ArrayTools from "../../../helpers/ArrayTools";
import Filters from "../../../components/cotizacion/Filters";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import DownloadProducts from "../../../components/products/DownloadProducts";
import UploadProducts from "../../../components/products/UploadProducts";

import TicketTools from "../../../helpers/TicketTools";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "Requests",
  components: {
    Filters,
    OfficeLogin,
    DownloadProducts,
    UploadProducts,
  },
  data() {
    return {
      category_selected: null,
      show_celulares: false,
      show_accesorios: true,
      show_chips: false,
      title_table: null,
      search_sale: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Ventas",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        //{ text: 'NRO ORDEN', value: 'order_code' },
        { text: "CLIENTE", value: "customer_fullname", sortable: false },
        { text: "DNI/RUC", value: "document", sortable: false },
        { text: "FECHA REGISTRO", value: "registration_date" },
        // { text: 'EMPRESA', value: 'company_customer.name'},
        { text: "TOTAL", value: "total", width: 80 },
        {
          text: "COTIZACION",
          value: "orden",
          sortable: false,
          align: "center",
        },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
      filterAux: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getCotizaciones({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
          office_id: this.office_id,
          ...this.filterAux,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("offices", ["offices"]),
    ...mapState("cotizaciones", ["sale", "selected_sale", "paginated"]),
    ...mapState("categories", ["categories"]),
    ...mapState("report-sales", ["voucher"]),
  },
  methods: {
    /*1par=modulo, 2par=metodos */
    ...mapActions("cotizaciones", [
      "getCotizaciones",
      "change_status",
      "delete",
      "runCleanSales",
      "selectSale",
      "emptySales",
    ]),
    ...mapActions("categories", ["getCategories"]),
    ...mapActions("brands", ["getBrands"]),
    ...mapActions("cotizaciones", ["clear_set_select_cotizacion"]),

    /*...mapActions('units', [
            'getUnits'
        ]),*/
    ...mapActions("offices", ["getOffices"]),
    ...mapActions("report-sales", ["getSaleVoucher", "getCotizacionVoucher"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        //let item = item.offices && item.offices.length == 1 && item.offices[0].active
        let item = this.selectedRows[0];
        if (item.offices && item.offices.length == 1) {
          this.show_btn_active = !item.offices[0].active;
        }
        //this.show_btn_active = !this.selectedRows[0].active
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    /*handleEdit() {
            let product = this.selectedRows[0];
            this.selectedRows = [];
            this.showOptionCrud();
            this.selectProduct(product);
            router.push('/app/logistica/datos-producto');
        },*/
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de Cotizacion");
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    handleShowCreate() {
      //router.push('/app/logistica/datos-producto');
      router.push("/app/ventas/nueva-cotizacion");
    },

    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        office_id: this.office_id,
      };

      if (!isNaN(this.search_sale))
        filters = { ...filters, document: this.search_sale };
      else filters = { ...filters, fullname: this.search_sale };

      await this.getCotizaciones(filters);
    },
    async handleChangeStatus() {
      let product = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(product);
    },
    async handleDelete() {
      let product = this.selectedRows[0];
      await this.delete(product);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    handleDownload() {
      this.$refs.downloadProducts.show();
    },
    handleUpload() {
      this.$refs.uploadProducts.show();
    },
    async load() {
      //console.log(this.getSales());
      // this.getCategories();
      // this.getBrands();
      //this.getUnits();
      // this.getOffices();
      // let filters = {
      //   office_id: this.office_id,
      //   date_from: this.$moment()
      //     .subtract(7, "days")
      //     .format("YYYY-MM-DD"),
      //   date_until: this.$moment().format("YYYY-MM-DD"),
      // };
      // await this.getCotizaciones(filters);
      //console.log(this.sales)
    },
    /*async handlePrintVoucher (item) {
            //console.log(item);
            if (item) {
                let content = await TicketTools.printWorkOrder(item);
                this.printVoucher(content);
            }
            
        },*/
    async handlePrintVoucher(item) {
      //console.log(item.id);
      await this.getCotizacionVoucher(item.id);
      if (this.voucher) {
        let content = await TicketTools.printTicketCotizacion(this.voucher);
        this.printVoucher(content);
      }
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 500);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },
    convertCotizacionToSale(item) {
      this.clear_set_select_cotizacion(item.id);
      router.push("/app/atencion/datos-solicitud-venta");
    },
    async hanleChangeFilter(value) {
      this.filterAux = value;
      await this.getCotizaciones(value);
    },
  },
  created() {
    this.emptySales();
    this.selectSale(null);
    this.load();
  },
  destroyed() {
    this.emptySales();
  },
};
</script>

<style scoped>
.section-categories {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto, sans-serif !important;
}

.header-table-products {
  vertical-align: baseline !important;
  padding-top: 5px !important;
}

.v-data-table-header > tr > th {
  color: #263238 !important;
  vertical-align: baseline !important;
  padding-top: 5px !important;
}
</style>
